import React, {useEffect} from "react";
import { useState } from "react";
import { useLocation} from "react-router-dom";
import { useHistory } from "react-router-dom";
import NavigationBar from "../NavigationBar";
import AdminEditProfileForm from "./adminEditProfileForm";
import { axiosLogin } from "../services/loginService";

const AdminEditProfile = () => {
    let location = useLocation()
    const [admin,setAdmin] = useState('')
    const history = useHistory()

    //this hook checks if the user is logged in. If not the user is redirected to the home page.
    useEffect( () =>{
        axiosLogin().
            then(response => {
                if(response.data.uType=="3")
                    setAdmin(response.data)
                else
                {
                    alert("You need admin rights to access this page!!");
                    history.push('/home')
                }
            }
                      
            ).catch((e) => {
                alert("Login before accessing the page!");
                history.push("/home")
            });
        }, []);
    
    return(
        <>
            {/*<NavigationBar/>*/}
            <AdminEditProfileForm user={location.state}/>
        </>
    )
}

export default AdminEditProfile;